import actionTypes from "constants/fuelCards";
import { Action, ActionFunctionAny, createActions } from "redux-actions";
import { allFuelCards, carFuelCards, driverFuelCards, unlinkedFuelCards } from "sources/books/fuelCards";

const {
    GET_ALL_FUEL_CARDS,
    GET_UNLINKED_FUEL_CARDS,
    GET_DRIVER_FUEL_CARDS,
    GET_CAR_FUEL_CARDS,
    SET_FUEL_CARDS_LOADING,
    MERGE_FUEL_CARDS_PARAMS,
} = actionTypes;

const actions = createActions(
    GET_ALL_FUEL_CARDS,
    GET_UNLINKED_FUEL_CARDS,
    GET_DRIVER_FUEL_CARDS,
    GET_CAR_FUEL_CARDS,
    SET_FUEL_CARDS_LOADING,
    MERGE_FUEL_CARDS_PARAMS,
);

const cardsListRequestsMapper = {
    getAllFuelCards: allFuelCards,
    getUnlinkedFuelCards: unlinkedFuelCards,
    getDriverFuelCards: driverFuelCards,
    getCarFuelCards: carFuelCards,
} as const;

type KeyTypes = keyof typeof cardsListRequestsMapper;

const generateListActions = () => {
    return Object.keys(cardsListRequestsMapper).reduce(
        (acc, key) => {
            acc[key as KeyTypes] =
                (params: { [x: string]: any; preparedFilter: any }) =>
                (dispatch: ActionFunctionAny<Action<Object>>) => {
                    dispatch(actions.setFuelCardsLoading(true));
                    return cardsListRequestsMapper[key as KeyTypes](params)
                        .then((res: any) => {
                            dispatch(actions[key](res));
                        })
                        .finally(() => {
                            dispatch(actions.setFuelCardsLoading(false));
                        });
                };
            return acc;
        },
        {} as { [key in KeyTypes]: any },
    );
};

export default { ...actions, ...generateListActions() };
